import { create } from 'zustand';

import { EventFormType } from '../../../types/events.types';

type Store = {
  isOpen: boolean;
  setOpenState: (payload: { state: boolean; type?: EventFormType }) => void;
  setType: (type: EventFormType) => void;
  type: EventFormType | null;
};

export const eventModalStore = create<Store>()((set) => ({
  isOpen: false,
  type: null,

  setOpenState: ({ state, type }) =>
    set(() =>
      state
        ? {
            isOpen: state,
            type: type ?? null,
          }
        : { type: null, isOpen: false },
    ),

  setType: (type) => set(() => ({ type })),
}));
